module.exports = __webpack_public_path__ + "img/condition_en.492372bb.jpg";